<div class="locked-state">
    <img src="../../../assets/images/lock-icon.svg"/>
    <h3>Widget Locked</h3>
    <p>Attempt a few tests to unlock this powerful widget<br class="d-none d-sm-block"> and boost your smart study toolkit.</p>
</div>
